import React, {useCallback} from 'react';
import OAuthActions from 'actions/OAuthActions';
import {Stoplight} from '@components/integrations/Stoplight';

export interface IntegrationCardProps {
  name: string;
  state: 'red' | 'yellow' | 'green';
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({name, state}) => {
  const redirectURI = useCallback(() => {
    OAuthActions.redirectUrl(name);
  }, [name]);

  return <Stoplight name={name} state={state} onClick={redirectURI} />;
};
